import StartTestBtn from './StartTestBtn';

export default StartTestBtn;
